import ReactGA from "react-ga4";
    ReactGA.initialize('G-11WCKS1P3R');

export const Analytics = (category,action,label,id) => {

    ReactGA.event({
        category: `${category}`,           // Event category
        action: `${action}`,        // Event action
        label: `${label}`,          // Event label
        value: id,               // Optional value (e.g., 1 or any other numerical value)
        non_interaction: false,     // Se
    });
}